(() => {
  const init = () => {
    const root = document.querySelector('.mvc');
    if (!root || root.dataset.ready === 'true') return;
    const findForm = () => [...document.querySelectorAll('form[action*="/cart/add"]')].find(form => {
      const style = getComputedStyle(form);
      const rect = form.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0;
    });
    const goToForm = () => {
      const form = findForm();
      if (!form) return;
      form.scrollIntoView({ behavior: 'auto', block: 'center' });
      updateSticky();
    };
    const sticky = root.querySelector('.mvc__sticky');
    const updateSticky = () => {
      if (!sticky || innerWidth > 780) return;
      const form = findForm();
      if (!form) return sticky.classList.remove('is-visible');
      const rect = form.getBoundingClientRect();
      const visible = rect.bottom > 0 && rect.top < innerHeight;
      sticky.classList.toggle('is-visible', !visible && scrollY > 240);
    };
    const gallery = document.querySelector('media-gallery');
    if (gallery && gallery.dataset.vaporReady !== 'true') {
      const mediaList = gallery.querySelector('.product__media-list');
      if (mediaList) mediaList.style.scrollBehavior = 'auto';
      gallery.querySelectorAll('.product__media-item img').forEach((image, index) => {
        image.loading = 'eager';
        if (index === 0) image.fetchPriority = 'high';
        image.decode().catch(() => {});
      });
      gallery.querySelectorAll('button.thumbnail').forEach(button => {
        button.addEventListener('click', () => {
          const targetId = button.closest('[data-target]')?.dataset.target;
          const target = targetId ? document.getElementById(targetId) : null;
          const image = target?.querySelector('img');
          if (image) {
            image.loading = 'eager';
            image.decode().catch(() => {});
          }
          if (mediaList && target) {
            setTimeout(() => {
              mediaList.scrollLeft = Math.max(0, target.offsetLeft - mediaList.offsetLeft);
            }, 0);
          }
        });
      });
      gallery.dataset.vaporReady = 'true';
    }
    root.querySelectorAll('[data-vapor-buy]').forEach(button => button.addEventListener('click', goToForm));
    addEventListener('scroll', updateSticky, { passive: true });
    addEventListener('resize', updateSticky, { passive: true });
    root.dataset.ready = 'true';
    updateSticky();
    setInterval(updateSticky, 1200);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  setTimeout(init, 800);
})();
